import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';

export default function UploadForm({ onResult }) {
    const [file, setFile] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');

    const onSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!file) {
            setError('Выберите .docx файл.');
            return;
        }
        try {
            setBusy(true);
            const { uploadDocx } = await import('../services/api');
            const data = await uploadDocx(file);
            onResult(data);
        } catch (err) {
            console.error(err);
            setError(err?.response?.data?.error || 'Ошибка загрузки/конвертации.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <Form onSubmit={onSubmit} className="mb-3">
            {error && <Alert variant="danger" className="mb-3">{error}</Alert>}
            <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>Загрузите Word документ (.docx)</Form.Label>
                <Form.Control
                    type="file"
                    accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    onChange={(e) => setFile(e.target.files?.[0] || null)}
                    disabled={busy}
                />
            </Form.Group>
            <Button type="submit" disabled={busy}>
                {busy ? 'Конвертация…' : 'Конвертировать в HTML'}
            </Button>
        </Form>
    );
}